export class RepresentativesModel {

    public id: string;
    public firstName: string;
    public lastName: string;
    public middleName: string;
    public personalNumber: string;
    public note: string;

    constructor(obj?: any) {
        this.id             = obj && obj.id             || '';
        this.firstName      = obj && obj.firstName      || '';
        this.lastName       = obj && obj.lastName       || '';
        this.middleName     = obj && obj.middleName     || '';
        this.personalNumber = obj && obj.personalNumber || '';
        this.note           = obj && obj.note           || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/representatives.model.ts